import React, { Component } from "react";
import { Link, Redirect, withRouter, NavLink } from "react-router-dom";
import pako from "pako";
import * as actionFunction from "../../../actions/common";
import $ from "jquery";
import moment, { unix } from "moment";
import Header from "../../../Header";
import HeaderMob from "../../../HeaderMob";
import CryptoJS from "crypto-js";
import config from "react-global-configuration";
import EditorNew from "../../Editor/EditorNew";
import "../../chat/chat.css";
import ProductStoreDetailsNew from "./ProductStoreDetailsNew";
import CustomSelect from "../../multiselectcustom/CustomSelect";
import CustomModal from "../modals/CustomModal";
import WarningModal from "../../WarningModal";
import MaskTableRow from "./MaskTableRow";
import { toast, Bounce } from "react-toastify";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Cookies from "js-cookie";

/// Create a functional component that wraps your class component
function NewCustomerDetailsWrapper(props) {
	return <NewLayoutDesign {...props} />;
}

class NewLayoutDesign extends Component {
	constructor() {
		super();
		// Bind the onChange method to `this`
		this.onChange = this.onChange.bind(this);

		var has_local_data = localStorage.getItem("encdata") ? 1 : 0;
		var localdata = has_local_data ? this.decrypt(localStorage.getItem("encdata"), 0) : "";
		this.state = {
			apiUrl: this.decryptconfigdata("apiUrl"),
			studioUrl: this.decryptconfigdata("studioUrl"),
			userAuthKey: has_local_data ? localdata.user_key : "",
			userId: parseInt(has_local_data ? localdata.user_id : 0),
			products: [],
			customer_details: {},
			billing_details: [],
			cards_list: [],
			applications: [],
			account_manager: {},
			showWarning: false,
			content_analytics: [],
			logo: "",
			loader: 1,
			showDelayedComponent: false,
			othernew_contacts: [],
			showModalHandler: false,
			get_billing_api: 0,
			showContactModal: false,
			get_content_api: 0,
			app_token: "",
			store_key: "",
			contactsEdit: {},
			selected_product_key: "",
			selected_products: [],
			muvi_ownership: [],
			crmNotes: [],
			deleteEmail: "",
			noteContent: "",
			isContactEdit: false,
			noteAdding: 0,
			isShowOwnerShip: false,
			isShowContactShip: false,
			noteError: false,
			isRbcUsers: false,
			editId: 1,
			userList: {},
			userType: "internal",
			note: "",
			userUUID: 0,
			contactIndex: "",
			chatInformation: {},
			other_contacts: [],
			chatDetail: {},
			customer_tattle_uuid: 0,
			customer_id: "",
			updateOwnerShip: {},
			customSelectValue: {},
			asyncApiData: {},
			isShowSideModal: false,
			storePermission: localStorage.getItem("store_permission"),
		};

		this.showmodalref = React.createRef(null);
		this.contactRef = React.createRef(null);
	}
	getQueryString() {
		const searchParams = new URLSearchParams(this.props.location.search);
		const queryString = searchParams.get("debug");
		const debug = queryString == null || queryString == "false" ? false : true;
		return debug;
	}
	getAPIQueryString() {
		const searchParams = new URLSearchParams(this.props.location.search);
		const queryString = searchParams.get("api");
		const isApiCall = queryString == null || queryString == "false" ? false : true;
		return isApiCall;
	}
	decryptconfigdata(configkey) {
		var key = CryptoJS.enc.Hex.parse(config.get("enc_key"));
		var iv = CryptoJS.enc.Hex.parse(config.get("enc_iv"));
		var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
			iv,
		});
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		return plaintext;
	}

	decrypt(findresponse, flg) {
		var key = CryptoJS.enc.Hex.parse(config.get("enc_key"));
		var iv = CryptoJS.enc.Hex.parse(config.get("enc_iv"));
		var res = flg ? findresponse.encdata : findresponse;
		var bytes = CryptoJS.AES.decrypt(res, key, {
			iv,
		});
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		return JSON.parse(plaintext);
	}

	handleAccountManager = (data) => {
		this.setState({ account_manager: data });
	};

	getRecentLogo() {
		let companyName = this.state.data && this.state.data.company_name ? this.state.data.company_name : "";
		if (!companyName) {
			const email = (this.state.data && this.state.data.email ? this.state.data.email : "") || "";
			companyName = email.substring(0, email.indexOf("@"));
			if (!companyName) {
				companyName = "Unknown";
			}
		}
        const logo = `https://ui-avatars.com/api/?name=${companyName}&color=ff0000&size=40&background=random`;

		return <img src={logo} alt="Logo" class="store-logo" />;
	}

	getLogo() {
		let columnsfetch = {
			email: this.state.customer_details.email,
			name: this.state.customer_details.name,
		};
		fetch(process.env.REACT_APP_CRM + "/muvi6/get-logo", {
			method: "POST",
			body: JSON.stringify(columnsfetch),
		})
			.then((Response) => Response.json())
			.then((findresponse) => {
				if (findresponse.code == 200) {
					this.setState({
						logo: findresponse.logo,
					});
				}
			})
			.catch((error) => {
				console.error("Fetch error:", error.message);
				// Handle fetch error
			});
	}

	getAllStoreDetails() {
		var appToken = this.props.match.params.appToken;
		const debug = this.getQueryString();

		let columnsfetch = {
			app_token: appToken,
			debug,
		};
		const compressedPostData = debug ? JSON.stringify(columnsfetch) : pako.gzip(JSON.stringify(columnsfetch));

		fetch(process.env.REACT_APP_CRM + "/muvi6/crm-data", {
			method: "POST",
			// headers: {
			// 	"X-Debug-Mode": debug,
			// },
			body: compressedPostData,
		})
			.then((response) => (debug ? response.json() : response.arrayBuffer())) // Get response body as ArrayBuffer
			.then((buffer) => {
				const findresponse = debug ? buffer : actionFunction.decompressjsondata(buffer);

				if (findresponse && findresponse.code === 200) {
					this.setState(
						{
							customer_details: findresponse.data.getCrmData.user_details,
							products: findresponse.data.getCrmData.user_details.products,
							selected_product_key:
								findresponse.data.getCrmData.user_details.products &&
									findresponse.data.getCrmData.user_details.products.length > 0
									? findresponse.data.getCrmData.user_details.products[0].product_key
									: null,
							selected_products:
								findresponse.data.getCrmData.user_details.products &&
									findresponse.data.getCrmData.user_details.products.length > 0
									? findresponse.data.getCrmData.user_details.products[0]
									: null,
							app_token: appToken,
							other_contacts: findresponse.users || [],
							data: {
								...this.state.data,
								...(findresponse.crm_user || {}),
							},
						},
						() => {
							this.getCrmNotes(this.state.data.customer_tattle_uuid);
						}
					);
				}
			}) /*
			.then((Response) => Response.json())
			.then((findresponse) => {
				if (findresponse.code == 200) {
					this.setState({
						customer_details: findresponse.data.getCrmData.user_details,
						products: findresponse.data.getCrmData.user_details.products,
						selected_product_key:
							findresponse.data.getCrmData.user_details.products && findresponse.data.getCrmData.user_details.products.length > 0
								? findresponse.data.getCrmData.user_details.products[0].product_key
								: null,
						selected_products:
							findresponse.data.getCrmData.user_details.products && findresponse.data.getCrmData.user_details.products.length > 0
								? findresponse.data.getCrmData.user_details.products[0]
								: null,
						app_token: appToken,
					});
					//selected_product_key: findresponse.data.getCrmData.user_details.products[0].product_key,
					//selected_products: findresponse.data.getCrmData.user_details.products[0],
				}
			})*/
			// .then(() => {
			//   this.getLogo();
			// })
			.catch((error) => {
				console.error("Fetch error:", error);
				// Handle fetch error
			});
	}

	getMuviOwnerShipDetails() {
		//let crmStaging = process.env.REACT_APP_CRM + "/crm/details/" + this.props.match.params.appToken;
		const debug = this.getQueryString();
		let columnsfetch = {
			customer_id: this.props.match.params.appToken,
			debug,
		};
		const compressedPostData = debug ? JSON.stringify(columnsfetch) : pako.gzip(JSON.stringify(columnsfetch));
		fetch(process.env.REACT_APP_CRM + "/crm/details", {
			method: "POST",
			body: compressedPostData, //JSON.stringify(columnsfetch),
		})
			.then((response) => (debug ? response.json() : response.arrayBuffer())) // Get response body as ArrayBuffer
			.then((buffer) => {
				const data = debug ? buffer : actionFunction.decompressjsondata(buffer);
				if (data && data.code === 200 && data.data) {
					this.setState(
						{
							muvi_ownership: data.data[0].muvi_ownership || [], // Use empty array as fallback if ownership_details is not available
							customer_tattle_uuid: data.data[0].customer_tattle_uuid,
							logo: data.data[0].logo,
							data: data.data[0],
							other_contacts: data.data[0].other_contacts || [],
							customer_id: data.data[0].customer_id,
							loader: 0,
						},
						() => {
							this.getCrmNotes(this.state.data.customer_tattle_uuid);
						}
					);
				} else {
					this.setState({
						muvi_ownership: [], // Set muvi_ownership to empty array on error
						loader: 0,
					});
				}
			}) /*
			.then((data) => {
				if (data && data.code === 200 && data.data) {
					this.setState({
						muvi_ownership: data.data[0].muvi_ownership || [], // Use empty array as fallback if ownership_details is not available
						customer_tattle_uuid: data.data[0].customer_tattle_uuid,
						logo: data.data[0].logo,
						data: data.data[0],
						customer_id: data.data[0].customer_id,
						loader: 0,
					});
					this.getCrmNotes(data.data[0].customer_tattle_uuid);
				} else {
					console.error("API error! Response data:", data);
					this.setState({
						muvi_ownership: [], // Set muvi_ownership to empty array on error
						loader: 0,
					});
				}
			})*/
			.catch((error) => {
				console.error("Fetch error:", error); // Log any fetch errors
				this.setState({
					muvi_ownership: [], // Set muvi_ownership to empty array on error
					loader: 0,
				});
			});
	}

	/**
	 *
	 * Right Sidebar
	 */

	getCrmNotes = (id) => {
		const output = fetch(`${process.env.REACT_APP_tattle_api}/notes/list`, {
			method: "POST",
			body: JSON.stringify({
				customer_tattle_uuid: id,
				attribute_set_key: "crm",
				app_token: process.env.REACT_APP_tattle_token,
				attribute_set_type: 20,
				// customer_tattle_uuid: id,
				// attribute_set_key: "crm",
				// app_token: this.props.match.params.appToken,
				// attribute_set_type: 20,
			}),
		});

		output
			.then((i) => {
				return i.json();
			})
			.then((out) => {
				this.setState({
					crmNotes: out,
				});
			})
			.catch((error) => {
				console.error("Fetch error:", error.message);
				// Handle fetch error
			});
	};
	addChatNote = (chatData) => {
		this.setState({
			noteContent: chatData,
		});
	};

	onChange(event) {
		this.setState({
			userType: event.target.value,
		});
	}

	showManageOwnership = () => {
		this.setState((state) => {
			return {
				...state,
				showModalHandler: true,
			};
		});
	};

	showDeleteHandler = (email) => {
		this.setState((state) => {
			return {
				...state,
				showWarning: true,
				deleteEmail: email,
			};
		});
	};

	hideModalHanderHandler = () => {
		this.setState((state) => {
			return {
				...state,
				showModalHandler: false,
			};
		});
	};

	noteAdd = (e) => {
		e.preventDefault();
		this.setState({
			noteAdding: 1,
			editId: this.state.editId + 1,
		});
		const mentionIds = this.state.noteContent.mentioned_data;
		//console.log("note-", this.state.noteContent.chat_note.html_content);
		// console.log("user_uuid", this.state.userUUID);
		// console.log("app_token", this.state.customer_details.app_token);
		// console.log("customer_id", this.props.match.params.appToken);
		//console.log("customer_tattle_uuid  :", this.state.customer_tattle_uuid);
		/*
		if (this.state.userType == "" && this.state.userType.length == 0) {
			this.setState({
				noteError: true,
				noteAdding: 0,
			});
			return false;
		} else {
			this.setState({
				noteError: false,
				noteAdding: 0,
			});
		}
		*/
		if (this.state.noteContent && this.state.noteContent.chat_note.html_content == "") {
			this.setState({
				noteError: true,
				noteAdding: 0,
			});
			return false;
		} else {
			this.setState({
				noteError: false,
				noteContent: "",
				note: this.state.noteContent.chat_note.html_content,
			});

			setTimeout(() => {
				fetch(`${process.env.REACT_APP_tattle_api}/note/create`, {
					method: "POST",
					body: JSON.stringify({
						attribute_set_key: "crm",
						app_token: process.env.REACT_APP_tattle_token,
						customer_tattle_uuid: this.state.data.customer_tattle_uuid,
						user_uuid: this.state.userUUID,
						note_content: this.state.note,
						note_content_json: JSON.stringify(
							this.state.noteContent.chat_note.draft_js_content &&
							this.state.noteContent.chat_note.draft_js_content
						),

						mention: mentionIds && mentionIds,
						note_type: this.state.userType,
						attribute_set_type: 5,
					}),
				})
					.then((item) => {
						return item.json();
					})
					.then((data) => {
						//console.log("Insert Data -", data);
						this.setState({
							noteAdding: 0,
						});
						//this.state.muvi_ownership.customer_tattle_uuid
						this.getCrmNotes(this.state.data.customer_tattle_uuid);
						this.setState({
							note: "",
						});
					})
					.catch((error) => {
						console.error("Fetch error:", error.message);
						// Handle fetch error
					});
			}, 1000);
		}
	};

	asyncApiCall = async (evt, url, key) => {
		if (evt && this.state.asyncApiData[key].length > 0) {
			return this.state.asyncApiData[key].filter((item) => item.label.toLowerCase().includes(evt.toLowerCase()));
		}
		try {
			const fetchResponse = await fetch(url).catch((err) => console.log(err.message));
			const rdata = await fetchResponse.json();
			if (rdata.code === 200) {
				const { data } = rdata;
				let salsdata = data.map((item) => ({
					label: item.name,
					value: item.user_uuid,
					image: item.attachment,
				}));

				this.setState((state) => {
					return {
						...state,
						asyncApiData: { ...state.asyncApiData, [key]: salsdata },
					};
				});
				return salsdata;
			}
		} catch (err) {
			console.log(err.message);
		}
	};

	ownerShipHandler = (name, evt, url) => {
		let ownership = { ...this.state.updateOwnerShip };
		let tempvalue = { ...this.state.customSelectValue };
		if (evt) {
			ownership = {
				...ownership,
				[name]: evt.value,
			};
			tempvalue = {
				...tempvalue,
				[name]: { label: evt.label, value: evt.value, image: evt.image },
			};
		} else {
			ownership = {
				...ownership,
				[name]: "",
			};
			tempvalue = {
				...tempvalue,
				[name]: {
					label: evt ? evt.label : "",
					value: evt ? evt.value : "",
					image: evt ? evt.image : "",
				},
			};
		}

		this.setState((state) => {
			return {
				...state,
				updateOwnerShip: ownership,
				customSelectValue: tempvalue,
			};
		});
	};

	ownerShipSubmitHandler = async (evt) => {
		evt.preventDefault();
		const muviowner = [...this.state.muvi_ownership];
		let newowner = { ...this.state.updateOwnerShip };

		if (this.state.data.hasOwnProperty("account_manager") && this.state.data.account_manager) {
			newowner = {
				account_manager: this.state.data.account_manager,
				...newowner,
			};
		}

		if (this.state.data.hasOwnProperty("sales_manager") && this.state.data.sales_manager) {
			newowner = { sales_manager: this.state.data.sales_manager, ...newowner };
		}

		if (this.state.data.hasOwnProperty("tse_owner") && this.state.data.tse_owner) {
			newowner = { tse_owner: this.state.data.tse_owner, ...newowner };
		}

		try {
			if (Object.keys(newowner).length > 0) {
				const userUUID = Cookies.get("muvi_useruuid");
				const responsedata = await fetch(`${process.env.REACT_APP_CRM}/muvi6/manage-muvi-ownership`, {
					method: "POST",
					body: JSON.stringify({
						product_key: "3D28C83C85544F0D9517DD2E7C7EEDAA",
						customer_id: this.props.match.params.appToken,
						last_updated_by: userUUID,
						...newowner,
						is_live: false,
					}),
				});
				const response = await responsedata.json();
				if (response && response.code === 200) {
					// Fill blank objects with available data
					toast.success(response.message, {
						position: "top-right",
						autoClose: 1000,
						hideProgressBar: false,
						closeOnClick: true,
						pauseOnHover: true,
						draggable: true,
						progress: undefined,
						theme: "light",
						transition: Bounce,
					});
					this.setState((state) => {
						return {
							...state,
							data: {
								...state.data,
								...this.state.updateOwnerShip,
							},
							showModalHandler: false,
						};
					});
				} else {
					const errorMessage = response && response.message ? response.message : "An error occurred";
					toast.error(errorMessage, {
						position: "top-right",
						autoClose: 1000,
						hideProgressBar: false,
						closeOnClick: true,
						pauseOnHover: true,
						draggable: true,
						progress: undefined,
						theme: "light",
						transition: Bounce,
					});
				}
			}
			const backdrop = document.querySelector(".modal-backdrop");
			backdrop.style.display = "none";
			this.showmodalref.current.classList.remove("show");
			this.showmodalref.current.style.display = "none";
			// after modal Close pages are workable
			document.body.classList.remove("modal-open");
		} catch (err) {
			console.log(err.message);
		}
	};

	handleCloseWarningModal = () => {
		this.setState((state) => {
			return {
				...state,
				showWarning: false,
			};
		});
	};

	userLists() {
		fetch(`${process.env.REACT_APP_CRM}/user-list`, {
			method: "POST",
		})
			.then((resp) => {
				return resp.json();
			})
			.then((data) => {
				if (data.code == 200) {
					this.setState({
						userList: data.data,
					});
					const userData = data.data;
					for (const key in userData) {
						if (userData.hasOwnProperty(key)) {
							const user = userData[key];
							if (user.emp_id == this.state.userId) {
								//let userUuid = user.user_uuid;
								this.setState({
									userUUID: user.user_uuid,
								});
								break;
							}
						}
					}
				}
			});
	}

	showMuviOwnerShipHandler = () => {
		this.showmodalref.current.classList.add("show");
		this.showmodalref.current.classList.add("in");
	};

	componentDidMount() {
		document.title = "Intranet | Customer Details";
		if (!localStorage.getItem("userLogin")) {
			this.setState({ redirect: true });
		}

		this.getAllStoreDetails();
		// this.getMuviOwnerShipDetails();
		this.userLists();
		//this.getCrmNotes(this.state.customer_tattle_uuid); //this.state.muvi_ownership.customer_tattle_uuid
		//console.log("tattleid :", this.state.customer_tattle_uuid);
		this.timer = setTimeout(() => {
			this.setState({ showDelayedComponent: true });
		});
	}

	componentWillUnmount() {
		// Clear the timeout to avoid memory leaks if the component unmounts
		clearTimeout(this.timer);
	}

	handleTabClick = (product) => {
		this.setState({ selected_product_key: product.product_key });
		this.setState({ selected_products: product });
		this.productStore();
	};

	productStore(billing = null) {
		return (
			<div class="tab-content" style={{ paddingTop: "10px" }}>
				<div role="tabpanel" class="tab-pane active" id="one">
					<ProductStoreDetailsNew
						products={this.state.selected_products}
						product_key={this.state.selected_product_key}
						app_token={this.state.app_token}
						customer_id={this.props.match.params.appToken}
						store_key={this.state.customer_details.store_key}
						source={this.state.customer_details.source}
						user_uuid={this.state.customer_details.user_uuid}
						number_of_login={this.state.customer_details.number_of_login}
						account_manager={this.state.account_manager}
						getAccountManager={this.handleAccountManager}
						isDebug={this.getQueryString()}
						isApi={this.getAPIQueryString()}
						billing={billing}
						handleTabClick={(data) => this.handleTabClick(data)}
						productArray={this.state.products || []}
					/>
				</div>
			</div>
		);
	}
	showSideModalHandler = () => {
		this.setState((state) => {
			return {
				...state,
				isShowSideModal: true,
				isContactEdit: false,
			};
		});
	};

	hideSideModal = () => {
		this.setState((state) => {
			return {
				...state,
				isShowSideModal: false,
			};
		});
	};

	saveOtherContacts = async (contact) => {
		let otherContacts = [...this.state.other_contacts];
		if (this.state.isContactEdit) {
			otherContacts[this.state.contactIndex] = { ...contact };
		} else {
			otherContacts.push(contact);
		}

		const request = {
			customer_id: this.props.match.params.appToken,
			other_contacts: contact,
		};
		try {
			const response = await fetch(process.env.REACT_APP_CRM + "/muvi6/manage-other-contacts", {
				method: "POST",
				body: JSON.stringify(request),
			});

			const resData = await response.json();

			if (resData.code === 200) {
				this.setState((state) => {
					return {
						...state,
						other_contacts: otherContacts,
						isContactEdit: false,
						contactsEdit: {},
					};
				});
				if (this.contactRef.current) {
					this.contactRef.current.classList.remove("in");
					this.contactRef.current.style.display = "none";
					document.querySelector(".modal-backdrop").classList.remove("in");
					document.querySelector(".modal-backdrop").style.display = "none";
				}
			} else {
				console.log(resData.message);
			}
		} catch (err) {
			console.log(err.message);
		}
	};

	toggleOwnerShipHandler = () => {
		this.setState((state) => {
			return {
				...state,
				isShowOwnerShip: !state.isShowOwnerShip,
			};
		});
	};
	toggleRbcUsers = () => {
		this.setState((state) => {
			return {
				...state,
				isRbcUsers: !state.isRbcUsers,
			};
		});
	};
	toggleContactShipHandler = () => {
		this.setState((state) => {
			return {
				...state,
				isShowContactShip: !state.isShowContactShip,
			};
		});
	};
	contactEditHandler = (index) => {
		let otherContacts = [...this.state.other_contacts];

		const editcontact = otherContacts[index];
		this.setState((state) => {
			return {
				...state,
				showContactModal: true,
				contactIndex: index,
				isContactEdit: true,
				contactsEdit: editcontact,
			};
		});
	};

	removeEditContact = () => {
		this.setState((state) => {
			return {
				...state,
				isContactEdit: false,
				contactsEdit: {
					name: "",
					email: "",
					designation: "",
					phone_number: "",
				},
				showContactModal: true,
			};
		});
	};

	addOtherContact = (ev) => {
		ev.preventDefault();
		this.setState((state) => {
			return {
				...state,
				showContactModal: true,
			};
		});
	};

	handleCloseModal = () => {
		this.setState((state) => {
			return {
				...state,
				showContactModal: false,
			};
		});
	};

	ownerShipModal = () => {
		return (
			<div
				className="modal fade"
				id="manageMuviOwnership"
				tabindex="-1"
				role="dialog"
				aria-labelledby="manageMuviOwnershipLabel"
				ref={this.showmodalref}
			>
				<div className="modal-dialog" role="document">
					<div className="modal-content">
						<div className="modal-header">
							<button
								type="button"
								className="close"
								data-dismiss="modal"
								aria-label="Close"
							// onClick={handleClose}
							>
								<span aria-hidden="true">&times;</span>
							</button>
							<h5 className="modal-title" id="manageMuviOwnershipLabel">
								Manage Muvi Ownership
							</h5>
						</div>
						<form onSubmit={this.ownerShipSubmitHandler}>
							<div className="modal-body">
								<div className="alert alert-info" role="alert">
									Note: Assigning an account manager will mark this customer as Key Account, to Unmark
									it please open customer details page and Unmark it.
								</div>

								<div class="form-group">
									<label for="recipient-name" className="control-label">
										Account Manager
									</label>

									<CustomSelect
										value={
											(this.state.customSelectValue &&
												this.state.customSelectValue.hasOwnProperty("account_manager") &&
												this.state.customSelectValue.account_manager) ||
											(this.state.data &&
												this.state.data.account_manager &&
												this.state.asyncApiData.hasOwnProperty("account_manager") &&
												this.state.asyncApiData.account_manager.length > 0 &&
												this.state.asyncApiData.account_manager.filter(
													(item) => item.value === this.state.data.account_manager
												))
										}
										options={Object.keys(this.state.userList).map((item) => {
											return {
												label: this.state.userList[item].name,
												value: this.state.userList[item].user_uuid,
												image: this.state.userList[item].profile_pic,
											};
										})}
										onChange={(evt) => this.ownerShipHandler("account_manager", evt)}
										async={true}
										loadOptions={(evt) =>
											this.asyncApiCall(
												evt,
												`${this.decryptconfigdata(
													"apiUrl"
												)}/tattle/GetGroupMembers?email=accountmanagement@muvi.com`,
												"account_manager"
											)
										}
									/>
								</div>
								<div class="form-group">
									<label for="recipient-name" className="control-label">
										TSE Owner
									</label>
									<CustomSelect
										value={
											(this.state.customSelectValue &&
												this.state.customSelectValue.hasOwnProperty("tse_owner") &&
												this.state.customSelectValue.tse_owner) ||
											(this.state.data &&
												this.state.data.tse_owner &&
												this.state.asyncApiData.hasOwnProperty("tse_owner") &&
												this.state.asyncApiData.tse_owner.length > 0 &&
												this.state.asyncApiData.tse_owner.filter(
													(item) => item.value === this.state.data.tse_owner
												))
										}
										async={true}
										loadOptions={(evt) =>
											this.asyncApiCall(
												evt,
												`${this.decryptconfigdata(
													"apiUrl"
												)}/tattle/GetGroupMembers?email=support@muvi.com`,
												"tse_owner"
											)
										}
										options={Object.keys(this.state.userList).map((item) => {
											return {
												label: this.state.userList[item].name,
												value: this.state.userList[item].user_uuid,
												image: this.state.userList[item].profile_pic,
											};
										})}
										onChange={(evt) => this.ownerShipHandler("tse_owner", evt)}
									/>
								</div>
								<div class="form-group">
									<label for="recipient-name" className="control-label">
										Sales Manager
									</label>
									<CustomSelect
										value={
											(this.state.customSelectValue &&
												this.state.customSelectValue.hasOwnProperty("sales_manager") &&
												this.state.customSelectValue.sales_manager) ||
											(this.state.data &&
												this.state.data.sales_manager &&
												this.state.asyncApiData.hasOwnProperty("sales_manager") &&
												this.state.asyncApiData.sales_manager.length > 0 &&
												this.state.asyncApiData.sales_manager.filter(
													(item) => item.value === this.state.data.sales_manager
												))
										}
										async={true}
										loadOptions={(evt) =>
											this.asyncApiCall(
												evt,
												`${this.decryptconfigdata(
													"apiUrl"
												)}/tattle/GetGroupMembers?email=sales@muvi.com`,
												"sales_manager"
											)
										}
										onChange={(evt) => this.ownerShipHandler("sales_manager", evt)}
									/>
								</div>
							</div>
							<div className="modal-footer">
								<span
									type="button"
									className="btn btn-blue"
									data-dismiss="modal"
								// onClick={handleClose}
								>
									Close
								</span>
								<button
									type="submit"
									className="btn btn-primary"
								// data-dismiss="modal"
								// onClick={handleSubmit}
								>
									Submit
								</button>
							</div>
						</form>
					</div>
				</div>
			</div>
		);
	};

	processDeleteHandler = async () => {
		const response = await fetch(`${process.env.REACT_APP_CRM}/muvi6/remove-other-contacts`, {
			method: "POST",
			body: JSON.stringify({
				customer_id: this.props.match.params.appToken,
				email: this.state.deleteEmail,
			}),
		});
		const rdata = await response.json();
		if (rdata.code === 200) {
			const contactsother = [...this.state.other_contacts];
			let newcontact = contactsother.filter((item) => item.email !== this.state.deleteEmail);
			this.setState((state) => {
				return {
					...state,
					other_contacts: newcontact,
					showWarning: false,
				};
			});
		}
	};
	render() {
		if (this.state.redirect) {
			return <Redirect to={"/login"} />;
		}

		const activeUserList = Object.keys(this.state.userList)
			.filter((key) => this.state.userList[key].is_active === 1)
			.reduce((acc, key) => {
				acc[key] = this.state.userList[key];
				return acc;
			}, {});

		return (
			<div>
				{this.state.showContactModal && (
					<CustomModal
						show={this.state.showContactModal}
						handleCloseModal={this.handleCloseModal}
						header="Add New Contact"
						company_name={this.state.customer_details.company_name}
						saveOtherContacts={this.saveOtherContacts}
						contactsEdit={this.state.contactsEdit}
					></CustomModal>
				)}
				{this.state.showWarning && (
					<WarningModal
						showWarning={this.state.showWarning}
						title={this.state.deleteEmail}
						body={"Are you sure to delete this contact?"}
						handleCloseWarningModal={this.handleCloseWarningModal}
						processDeleteHandler={this.processDeleteHandler}
					/>
				)}

				{this.state.showDelayedComponent && this.ownerShipModal()}

				<Header brecum_main="Accounts" brecum_name="Accounts" brecum_page="Account Details" />
				<ToastContainer />
				<div class="right_col fullchatarea">
					<div class="customer-details-area v2 notes crm">
						<div class="product-tab top-new-bar">
							<div class="row">
								<div class="col-md-12 border-end">
									<div class="top-area border-0">
										<div class="row">
											<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
												<ul class="nav nav-tabs" role="tablist">
													<li role="presentation" class="active">
														<a
															href="#overview"
															aria-controls="overview"
															role="tab"
															data-toggle="tab"
															aria-expanded="true"
														>
															Overview
														</a>
													</li>
													<li role="presentation" class="">
														<a
															href="#app"
															aria-controls="app"
															role="tab"
															data-toggle="tab"
															aria-expanded="false"
														>
															App Info
														</a>
													</li>
													<li role="presentation" class="">
														<a
															href="#login"
															aria-controls="login"
															role="tab"
															data-toggle="tab"
															aria-expanded="false"
														>
															Login
														</a>
													</li>
													<li role="presentation" class="">
														<a
															href="#upload"
															aria-controls="upload"
															role="tab"
															data-toggle="tab"
															aria-expanded="false"
														>
															Upload
														</a>
													</li>
													<NavLink
														to={{
															pathname: "/accounts/list",
															state: {
																pageNumber:
																	this.props.location &&
																	this.props.location.state &&
																	this.props.location.state.pageNumber,
															},
														}}
														className="back-toggle-btn"
													>
														<span
															style={{
																fontSize: "18px",
																lineHeight: "20px",
																color: "rgb(122, 122, 122)",
															}}
														>
															<svg
																stroke="currentColor"
																fill="currentColor"
																stroke-width="0"
																viewBox="0 0 24 24"
																height="1em"
																width="1em"
																xmlns="http://www.w3.org/2000/svg"
															>
																<path d="M21 11H6.414l5.293-5.293-1.414-1.414L2.586 12l7.707 7.707 1.414-1.414L6.414 13H21z"></path>
															</svg>
														</span>
													</NavLink>
												</ul>
											</div>
										</div>
										<div class="tab-content">
											<div role="tabpanel" class="tab-pane active" id="overview">
												<div class="row">
													<div class="col-md-6">
														<div class="profile-area border-0">
															<div class="profile-left">
																<div class="img-box">{this.getRecentLogo()} </div>
																<div class="text-area">
																	<div class="name">
																		{" "}
																		{this.state.customer_details.company_name
																			? this.state.customer_details.company_name
																			: "NA"}
																	</div>
																	<div class="email">
																		{this.state.customer_details.domain_name &&
																			this.state.customer_details.domain_name !==
																			"NA" && (
																				<a
																					href={`${this.state.customer_details.domain_name.startsWith(
																						"http://"
																					) ||
																						this.state.customer_details.domain_name.startsWith(
																							"https://"
																						)
																						? this.state
																							.customer_details
																							.domain_name
																						: `https://${this.state.customer_details.domain_name}`
																						}`}
																					target="_blank"
																					className="link_new_domain"
																				>
																					{this.state.customer_details
																						.domain_name
																						? this.state.customer_details
																							.domain_name
																						: "NA"}
																				</a>
																			)}
																	</div>
																	{this.state.customer_details.email && (
																		<a
																			href={`https://app.hubspot.com/contacts/570609/record/0-1/${this.state.customer_details.email}/`}
																			target="_blank"
																			rel="noopener noreferrer"
																			className="hubspot-button"
																		>
																			<i className="fas fa-link hubspot-icon"></i> Hubspot
																		</a>

																	)}
																</div>
															</div>
															<a
																class="add-new"
																data-toggle="modal"
																data-target="#add"
																onClick={this.removeEditContact}
															>
																<svg
																	width="16"
																	height="16"
																	viewBox="0 0 16 16"
																	fill="none"
																	xmlns="http://www.w3.org/2000/svg"
																>
																	<path
																		d="M8 3.33331V12.6666"
																		stroke="white"
																		stroke-width="1.33"
																		stroke-linecap="round"
																		stroke-linejoin="round"
																	></path>
																	<path
																		d="M3.33334 8H12.6667"
																		stroke="white"
																		stroke-width="1.33"
																		stroke-linecap="round"
																		stroke-linejoin="round"
																	></path>
																</svg>
																Add New
															</a>
														</div>
														<div
															class="table-wrap sticky-table"
															style={{ maxHeight: "270px" }}
														>
															<table>
																<thead>
																	<tr>
																		<th width="100">Name</th>
																		{/* <th width="170">Designation</th> */}
																		<th width="150">Email</th>
																		<th width="150">Phone No</th>
																		<th width="80"></th>
																	</tr>
																</thead>
																<tbody>
																	{Array.isArray(this.state.other_contacts) &&
																		this.state.other_contacts.map((con, index) => (
																			<MaskTableRow
																				name={con.name}
																				email={con.email}
																				is_edit={con.is_edit}
																				index={index}
																				phone_number={con.phone_number}
																				contactEditHandler={
																					this.contactEditHandler
																				}
																				showDeleteHandler={
																					this.showDeleteHandler
																				}
																			/>
																		))}
																</tbody>
															</table>
														</div>
														<div class="ownership">
															<div class="container-full">
																<div class="row">
																	<div class="col-xs-9">
																		<div class="title" style={{ marginTop: "5px" }}>
																			Muvi Ownership
																		</div>
																	</div>
																	<div class="col-xs-3 text-end">
																		{this.state.storePermission === "1" && (
																			<button
																				data-toggle="modal"
																				data-target="#manageMuviOwnership"
																				class="editprimary-btn"
																				style={{
																					marginRight: 0,
																					marginLeft: "auto",
																				}}
																				onClick={this.showManageOwnership}
																			>
																				<span>
																					{/* icon and colour change */}
																					<svg xmlns="http://www.w3.org/2000/svg" width="13" height="12" viewBox="0 0 13 12" fill="none">
																						<g clip-path="url(#clip0_568_443)">
																							<path d="M8.63336 1.50015C8.76468 1.36883 8.92059 1.26466 9.09217 1.19359C9.26375 1.12252 9.44764 1.08594 9.63336 1.08594C9.81908 1.08594 10.003 1.12252 10.1746 1.19359C10.3461 1.26466 10.502 1.36883 10.6334 1.50015C10.7647 1.63147 10.8689 1.78737 10.9399 1.95895C11.011 2.13054 11.0476 2.31443 11.0476 2.50015C11.0476 2.68587 11.011 2.86977 10.9399 3.04135C10.8689 3.21293 10.7647 3.36883 10.6334 3.50015L3.88336 10.2502L1.13336 11.0002L1.88336 8.25015L8.63336 1.50015Z" stroke="#006EFA" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round" />
																						</g>
																						<defs>
																							<clipPath id="clip0_568_443">
																								<rect width="12" height="12" fill="white" transform="translate(0.133362)" />
																							</clipPath>
																						</defs>
																					</svg>
																				</span>
																				Edit
																			</button>
																		)}
																	</div>
																</div>
																<div class="row">
																	<div class="col-lg-4 col-md-6 col-sm-6 col-xs-12">
																		<div class="single-box">
																			<div class="icon-box">
																				{/* icon and colour change */}
																				<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 25 24" fill="none">
																					<path d="M20.6 21V19C20.6 17.9391 20.1785 16.9217 19.4284 16.1716C18.6783 15.4214 17.6608 15 16.6 15H8.59998C7.53911 15 6.52169 15.4214 5.77155 16.1716C5.0214 16.9217 4.59998 17.9391 4.59998 19V21" stroke="#006EFA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
																					<path d="M12.6 11C14.8091 11 16.6 9.20914 16.6 7C16.6 4.79086 14.8091 3 12.6 3C10.3908 3 8.59998 4.79086 8.59998 7C8.59998 9.20914 10.3908 11 12.6 11Z" fill="#006EFA" stroke="#006EFA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
																				</svg>
																			</div>
																			<div class="only-text">
																				<div class="top-text">
																					Account Manager
																				</div>
																				<div class="bottom-text">
																					{this.state.data &&
																						this.state.data.account_manager &&
																						this.state.data.account_manager != 0
																						? this.state.asyncApiData
																							.account_manager &&
																							this.state.asyncApiData.account_manager.find(
																								(item) =>
																									item.value ===
																									this.state.data
																										.account_manager
																							)
																							? this.state.asyncApiData.account_manager.find(
																								(item) =>
																									item.value ===
																									this.state.data
																										.account_manager
																							).label
																							: "-NA-"
																						: "-NA-"}{" "}
																				</div>
																			</div>
																		</div>
																	</div>
																	<div class="col-lg-4 col-md-6 col-sm-6 col-xs-12">
																		<div class="single-box">
																			<div class="icon-box">
																				{/* icon and colour change */}
																				<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 25 24" fill="none">
																					<path d="M20.6 21V19C20.6 17.9391 20.1785 16.9217 19.4284 16.1716C18.6783 15.4214 17.6608 15 16.6 15H8.59998C7.53911 15 6.52169 15.4214 5.77155 16.1716C5.0214 16.9217 4.59998 17.9391 4.59998 19V21" stroke="#006EFA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
																					<path d="M12.6 11C14.8091 11 16.6 9.20914 16.6 7C16.6 4.79086 14.8091 3 12.6 3C10.3908 3 8.59998 4.79086 8.59998 7C8.59998 9.20914 10.3908 11 12.6 11Z" fill="#006EFA" stroke="#006EFA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
																				</svg>
																			</div>
																			<div class="only-text">
																				<div class="top-text">TSE Owner</div>
																				<div class="bottom-text">
																					{this.state.data &&
																						this.state.data.tse_owner &&
																						this.state.data.tse_owner != 0
																						? this.state.asyncApiData
																							.tse_owner &&
																							this.state.asyncApiData.tse_owner.find(
																								(item) =>
																									item.value ===
																									this.state.data
																										.tse_owner
																							)
																							? this.state.asyncApiData.tse_owner.find(
																								(item) =>
																									item.value ===
																									this.state.data
																										.tse_owner
																							).label
																							: "-NA-"
																						: "-NA-"}{" "}
																				</div>
																			</div>
																		</div>
																	</div>
																	<div class="col-lg-4 col-md-6 col-sm-6 col-xs-12">
																		<div class="single-box">
																			<div class="icon-box">
																				{/* icon and colour change */}
																				<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 25 24" fill="none">
																					<path d="M20.6 21V19C20.6 17.9391 20.1785 16.9217 19.4284 16.1716C18.6783 15.4214 17.6608 15 16.6 15H8.59998C7.53911 15 6.52169 15.4214 5.77155 16.1716C5.0214 16.9217 4.59998 17.9391 4.59998 19V21" stroke="#006EFA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
																					<path d="M12.6 11C14.8091 11 16.6 9.20914 16.6 7C16.6 4.79086 14.8091 3 12.6 3C10.3908 3 8.59998 4.79086 8.59998 7C8.59998 9.20914 10.3908 11 12.6 11Z" fill="#006EFA" stroke="#006EFA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
																				</svg>
																			</div>
																			<div class="only-text">
																				<div class="top-text">
																					Sales Manager
																				</div>
																				<div class="bottom-text">
																					{this.state.data &&
																						this.state.data.sales_manager &&
																						this.state.data.sales_manager != 0
																						? this.state.asyncApiData
																							.sales_manager &&
																							this.state.asyncApiData.sales_manager.find(
																								(item) =>
																									item.value ===
																									this.state.data
																										.sales_manager
																							)
																							? this.state.asyncApiData.sales_manager.find(
																								(item) =>
																									item.value ===
																									this.state.data
																										.sales_manager
																							).label
																							: "-NA-"
																						: "-NA-"}{" "}
																				</div>
																			</div>
																		</div>
																	</div>
																</div>
															</div>
														</div>

														{/* <div class="bottom-area">
                              {this.productStore("revenueandbilling")}
                            </div> */}
														<React.Fragment>{this.productStore()}</React.Fragment>
													</div>

													<div class="col-md-6">
														<div class="full-chat-area">
															<div class="chat-middle">
																<ul class="nav nav-tabs" role="tablist" id="myTab">
																	{/* <li>
                                    <a
                                      href="#notes"
                                      role="tab"
                                      data-toggle="tab"
                                      aria-expanded="false"
                                    >
                                      notes
                                    </a>
                                  </li> */}
																	<li class="active">
																		<a
																			href="#notes"
																			role="tab"
																			data-toggle="tab"
																			aria-expanded="true"
																		>
																			Notes
																		</a>
																	</li>
																</ul>
																<div class="tab-content">
																	<div class="tab-pane active" id="notes">
																		<div class="note-viewarea">
																			{this.state.noteError ? (
																				<label className="note-error-msg">
																					Please fill the field *
																				</label>
																			) : (
																				""
																			)}

																			<div class="check-wrap">
																				{this.state.userType == "internal" ? (
																					<div class="input-groups">
																						<span class="input-group-addons">
																							<input
																								type="radio"
																								name="clouds"
																								id="Clear"
																								value="internal"
																								onChange={this.onChange}
																								checked
																							/>
																						</span>
																						<label for="">Internal</label>
																					</div>
																				) : (
																					<div class="input-groups">
																						<span class="input-group-addons">
																							<input
																								type="radio"
																								name="clouds"
																								id="Clear"
																								value="internal"
																								onChange={this.onChange}
																							/>
																						</span>
																						<label for="">Internal</label>
																					</div>
																				)}
																				{this.state.userType == "external" ? (
																					<div class="input-groups">
																						<span class="input-group-addons">
																							<input
																								type="radio"
																								name="clouds"
																								id="Cloudy"
																								value="external"
																								onChange={this.onChange}
																								checked
																							/>
																						</span>
																						<label for="">Customer</label>
																					</div>
																				) : (
																					<div class="input-groups">
																						<span class="input-group-addons">
																							<input
																								type="radio"
																								name="clouds"
																								id="Cloudy"
																								value="external"
																								onChange={this.onChange}
																							/>
																						</span>
																						<label for="">Customer</label>
																					</div>
																				)}
																			</div>
																			<form class="form-area">
																				{Object.keys(this.state.userList)
																					.length > 0 && (
																						<EditorNew
																							getEditorData={this.addChatNote}
																							noteAdd={this.noteAdd}
																							show_toolbar={true}
																							field_name="chat_note"
																							edit_id={this.state.editId}
																							noteAdding={
																								this.state.noteAdding
																							}
																							// users={
																							// 	this.state.userList || {}
																							// }
																							users={activeUserList}
																						/>
																					)}
																			</form>
																			<div class="note-content-area">
																				{this.state.crmNotes.data &&
																					this.state.crmNotes.data.map(
																						(item) => {
																							return (
																								<div
																									class={`single-content ${item.note_type ===
																										"external" ||
																										item.note_type ===
																										"customer"
																										? "customer"
																										: "internal"
																										}`}
																								>
																									<div class="img-box">
																										<img
																											src={
																												this
																													.state
																													.userList[
																												item
																													.user_uuid
																												] &&
																												this
																													.state
																													.userList[
																													item
																														.user_uuid
																												]
																													.profile_pic
																											}
																										/>
																									</div>
																									<div class="item-area">
																										<div class="title-area">
																											<h5>
																												<a href="#">
																													{this
																														.state
																														.userList[
																														item
																															.user_uuid
																													] &&
																														this
																															.state
																															.userList[
																															item
																																.user_uuid
																														]
																															.name}{" "}
																												</a>
																											</h5>
																											{item.note_type ==
																												"external" ? (
																												<div class="bagde-customer">
																													Customer
																												</div>
																											) : (
																												<div class="bagde-internal">
																													Internal
																												</div>
																											)}
																											{/* 
                                                      <div
                                                        class="editNote"
                                                        data-toggle="modal"
                                                        data-target="#edit-note"
                                                      >
                                                        <svg
                                                          width="14"
                                                          height="15"
                                                          viewBox="0 0 14 15"
                                                          fill="none"
                                                          xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                          <path
                                                            d="M10.7974 1.36955C10.9725 1.19445 11.1803 1.05556 11.4091 0.960795C11.6379 0.866034 11.8831 0.817261 12.1307 0.817261C12.3783 0.817261 12.6235 0.866034 12.8523 0.960795C13.0811 1.05556 13.2889 1.19445 13.464 1.36955C13.6391 1.54464 13.778 1.75251 13.8728 1.98128C13.9675 2.21006 14.0163 2.45526 14.0163 2.70288C14.0163 2.9505 13.9675 3.1957 13.8728 3.42447C13.778 3.65325 13.6391 3.86112 13.464 4.03621L4.46403 13.0362L0.797363 14.0362L1.79736 10.3695L10.7974 1.36955Z"
                                                            stroke="#666666"
                                                            stroke-width="1.33"
                                                            stroke-linecap="round"
                                                            stroke-linejoin="round"
                                                          ></path>
                                                        </svg>
                                                      </div> */}
																										</div>
																										<div class="snote">
																											{moment(
																												unix(
																													item.created_timestamp
																												)
																											).format(
																												"MMMM D, YYYY"
																											)}
																										</div>
																										<div class="text-area">
																											{item.highlight_text ? (
																												<blockquote
																													class="quote-card"
																													dangerouslySetInnerHTML={{
																														__html: item.highlight_text,
																													}}
																												></blockquote>
																											) : (
																												""
																											)}
																											<div
																												dangerouslySetInnerHTML={{
																													__html: item.note_content,
																												}}
																											></div>
																										</div>
																									</div>
																								</div>
																							);
																						}
																					)}
																			</div>
																		</div>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
											<div role="tabpanel" class="tab-pane" id="app">
												<div class="row">
													<div className="not-data-found">
														<svg
															width="56"
															height="56"
															viewBox="0 0 56 56"
															fill="none"
															xmlns="http://www.w3.org/2000/svg"
														>
															<g clip-path="url(#clip0_504_30600)">
																<path
																	d="M48.5215 39.9595C48.959 40.7456 49.8374 41.1301 50.738 41.125C52.2693 41.1182 53.4963 42.4221 53.3647 43.979C53.2485 45.3582 52.0044 46.375 50.6201 46.375H42V47.25H6.12498C4.62791 47.25 3.42479 45.9973 3.5034 44.4849C3.5786 43.0647 4.85179 42 6.27366 42H6.99998C8.06297 42 8.90379 41.0532 8.72606 39.9561C8.58592 39.0964 7.77757 38.5 6.90599 38.5H2.62498C1.12791 38.5 -0.0752122 37.2473 0.00340108 35.7349C0.0785966 34.3147 1.35179 33.25 2.77366 33.25H8.31248C9.52073 33.25 10.5 32.2708 10.5 31.0625C10.5 29.8542 9.52073 28.875 8.31248 28.875C7.10423 28.875 6.12498 27.8958 6.12498 26.6875C6.12498 25.4792 7.10423 24.5 8.31248 24.5H15.75V18.375H9.18748C7.44261 18.375 6.03612 16.9138 6.13011 15.1484C6.21556 13.4924 7.70237 12.25 9.36009 12.25H15.75V8.75H49.4375C51.1824 8.75 52.5888 10.2112 52.4949 11.9766C52.4094 13.6326 50.9226 14.875 49.2649 14.875H46.8125C45.0676 14.875 43.6611 16.3362 43.7551 18.1016C43.8406 19.7576 45.3274 21 46.9851 21H49C50.5552 21 51.7942 22.3535 51.6062 23.9446C51.449 25.2656 50.2527 26.1953 48.9248 26.2517C47.8772 26.2944 47.0688 27.26 47.2842 28.3555C47.4499 29.186 48.2326 29.75 49.0786 29.75H52.9375C54.6824 29.75 56.0888 31.2112 55.9949 32.9766C55.9094 34.6326 54.4226 35.875 52.7649 35.875H50.75C48.8325 35.875 47.3952 37.9309 48.5215 39.9595ZM2.18748 28.875C3.39573 28.875 4.37498 27.8958 4.37498 26.6875C4.37498 25.4792 3.39573 24.5 2.18748 24.5C0.979231 24.5 -1.6893e-05 25.4792 -1.6893e-05 26.6875C-1.6893e-05 27.8958 0.979231 28.875 2.18748 28.875ZM2.18748 28.875C3.39573 28.875 4.37498 27.8958 4.37498 26.6875C4.37498 25.4792 3.39573 24.5 2.18748 24.5C0.979231 24.5 -1.6893e-05 25.4792 -1.6893e-05 26.6875C-1.6893e-05 27.8958 0.979231 28.875 2.18748 28.875Z"
																	fill="#EFF6FE"
																></path>
																<path
																	d="M12.8 49V7H34.7516L45.2 17.4484V49H12.8Z"
																	fill="white"
																></path>
																<path
																	d="M33.6747 7.60002C34.2052 7.60002 34.7139 7.81074 35.0889 8.18581L44.0142 17.111C44.3892 17.4861 44.6 17.9948 44.6 18.5253V46.4C44.6 47.5046 43.7045 48.4 42.6 48.4H15.4C14.2954 48.4 13.4 47.5046 13.4 46.4V9.60002C13.4 8.49545 14.2954 7.60002 15.4 7.60002H33.6747ZM35.5857 6.98581C35.2107 6.61074 34.702 6.40002 34.1715 6.40002H14.2C13.0954 6.40002 12.2 7.29545 12.2 8.40002V47.6C12.2 48.7046 13.0954 49.6 14.2 49.6H43.8C44.9045 49.6 45.8 48.7046 45.8 47.6V18.0285C45.8 17.498 45.5892 16.9893 45.2142 16.6142L35.5857 6.98581Z"
																	fill="#E2EAF3"
																></path>
																<path
																	d="M34.4 17.8V7H34.7516L45.2 17.4484V17.8H34.4Z"
																	fill="white"
																></path>
																<path
																	d="M35 8.09682L44.1032 17.2H37C35.8955 17.2 35 16.3046 35 15.2V8.09682ZM35 6.40002H33.8V16.4C33.8 17.5046 34.6955 18.4 35.8 18.4H45.8V17.2L35 6.40002Z"
																	fill="#E2EAF3"
																></path>
																<path
																	d="M32.6 29.4028L29 32.8L34.4648 38.8H38.6V35.2L32.6 29.4028Z"
																	fill="#7AADF0"
																></path>
																<path
																	d="M36.2 22C35.5635 22 34.9531 22.2529 34.503 22.7029C34.0529 23.153 33.8 23.7635 33.8 24.4C33.8 25.0365 34.0529 25.647 34.503 26.0971C34.9531 26.5471 35.5635 26.8 36.2 26.8C36.8365 26.8 37.447 26.5471 37.8971 26.0971C38.3472 25.647 38.6 25.0365 38.6 24.4C38.6 23.7635 38.3472 23.153 37.8971 22.7029C37.447 22.2529 36.8365 22 36.2 22ZM36.2 38.8H19.4V34L25.4 28L36.2 38.8Z"
																	fill="#B5DEFF"
																></path>
															</g>
															<defs>
																<clipPath id="clip0_504_30600">
																	<rect width="56" height="56" fill="white"></rect>
																</clipPath>
															</defs>
														</svg>
														<div class="mt-3">No Data found</div>
													</div>
												</div>
											</div>
											<div role="tabpanel" class="tab-pane" id="login">
												<div class="row">
													<div className="not-data-found">
														<svg
															width="56"
															height="56"
															viewBox="0 0 56 56"
															fill="none"
															xmlns="http://www.w3.org/2000/svg"
														>
															<g clip-path="url(#clip0_504_30600)">
																<path
																	d="M48.5215 39.9595C48.959 40.7456 49.8374 41.1301 50.738 41.125C52.2693 41.1182 53.4963 42.4221 53.3647 43.979C53.2485 45.3582 52.0044 46.375 50.6201 46.375H42V47.25H6.12498C4.62791 47.25 3.42479 45.9973 3.5034 44.4849C3.5786 43.0647 4.85179 42 6.27366 42H6.99998C8.06297 42 8.90379 41.0532 8.72606 39.9561C8.58592 39.0964 7.77757 38.5 6.90599 38.5H2.62498C1.12791 38.5 -0.0752122 37.2473 0.00340108 35.7349C0.0785966 34.3147 1.35179 33.25 2.77366 33.25H8.31248C9.52073 33.25 10.5 32.2708 10.5 31.0625C10.5 29.8542 9.52073 28.875 8.31248 28.875C7.10423 28.875 6.12498 27.8958 6.12498 26.6875C6.12498 25.4792 7.10423 24.5 8.31248 24.5H15.75V18.375H9.18748C7.44261 18.375 6.03612 16.9138 6.13011 15.1484C6.21556 13.4924 7.70237 12.25 9.36009 12.25H15.75V8.75H49.4375C51.1824 8.75 52.5888 10.2112 52.4949 11.9766C52.4094 13.6326 50.9226 14.875 49.2649 14.875H46.8125C45.0676 14.875 43.6611 16.3362 43.7551 18.1016C43.8406 19.7576 45.3274 21 46.9851 21H49C50.5552 21 51.7942 22.3535 51.6062 23.9446C51.449 25.2656 50.2527 26.1953 48.9248 26.2517C47.8772 26.2944 47.0688 27.26 47.2842 28.3555C47.4499 29.186 48.2326 29.75 49.0786 29.75H52.9375C54.6824 29.75 56.0888 31.2112 55.9949 32.9766C55.9094 34.6326 54.4226 35.875 52.7649 35.875H50.75C48.8325 35.875 47.3952 37.9309 48.5215 39.9595ZM2.18748 28.875C3.39573 28.875 4.37498 27.8958 4.37498 26.6875C4.37498 25.4792 3.39573 24.5 2.18748 24.5C0.979231 24.5 -1.6893e-05 25.4792 -1.6893e-05 26.6875C-1.6893e-05 27.8958 0.979231 28.875 2.18748 28.875ZM2.18748 28.875C3.39573 28.875 4.37498 27.8958 4.37498 26.6875C4.37498 25.4792 3.39573 24.5 2.18748 24.5C0.979231 24.5 -1.6893e-05 25.4792 -1.6893e-05 26.6875C-1.6893e-05 27.8958 0.979231 28.875 2.18748 28.875Z"
																	fill="#EFF6FE"
																></path>
																<path
																	d="M12.8 49V7H34.7516L45.2 17.4484V49H12.8Z"
																	fill="white"
																></path>
																<path
																	d="M33.6747 7.60002C34.2052 7.60002 34.7139 7.81074 35.0889 8.18581L44.0142 17.111C44.3892 17.4861 44.6 17.9948 44.6 18.5253V46.4C44.6 47.5046 43.7045 48.4 42.6 48.4H15.4C14.2954 48.4 13.4 47.5046 13.4 46.4V9.60002C13.4 8.49545 14.2954 7.60002 15.4 7.60002H33.6747ZM35.5857 6.98581C35.2107 6.61074 34.702 6.40002 34.1715 6.40002H14.2C13.0954 6.40002 12.2 7.29545 12.2 8.40002V47.6C12.2 48.7046 13.0954 49.6 14.2 49.6H43.8C44.9045 49.6 45.8 48.7046 45.8 47.6V18.0285C45.8 17.498 45.5892 16.9893 45.2142 16.6142L35.5857 6.98581Z"
																	fill="#E2EAF3"
																></path>
																<path
																	d="M34.4 17.8V7H34.7516L45.2 17.4484V17.8H34.4Z"
																	fill="white"
																></path>
																<path
																	d="M35 8.09682L44.1032 17.2H37C35.8955 17.2 35 16.3046 35 15.2V8.09682ZM35 6.40002H33.8V16.4C33.8 17.5046 34.6955 18.4 35.8 18.4H45.8V17.2L35 6.40002Z"
																	fill="#E2EAF3"
																></path>
																<path
																	d="M32.6 29.4028L29 32.8L34.4648 38.8H38.6V35.2L32.6 29.4028Z"
																	fill="#7AADF0"
																></path>
																<path
																	d="M36.2 22C35.5635 22 34.9531 22.2529 34.503 22.7029C34.0529 23.153 33.8 23.7635 33.8 24.4C33.8 25.0365 34.0529 25.647 34.503 26.0971C34.9531 26.5471 35.5635 26.8 36.2 26.8C36.8365 26.8 37.447 26.5471 37.8971 26.0971C38.3472 25.647 38.6 25.0365 38.6 24.4C38.6 23.7635 38.3472 23.153 37.8971 22.7029C37.447 22.2529 36.8365 22 36.2 22ZM36.2 38.8H19.4V34L25.4 28L36.2 38.8Z"
																	fill="#B5DEFF"
																></path>
															</g>
															<defs>
																<clipPath id="clip0_504_30600">
																	<rect width="56" height="56" fill="white"></rect>
																</clipPath>
															</defs>
														</svg>
														<div class="mt-3">No Data found</div>
													</div>
												</div>{" "}
											</div>
											<div role="tabpanel" class="tab-pane" id="upload">
												<span class="customer-detail-tab">
													<div class="row">
														<div className="not-data-found">
															<svg
																width="56"
																height="56"
																viewBox="0 0 56 56"
																fill="none"
																xmlns="http://www.w3.org/2000/svg"
															>
																<g clip-path="url(#clip0_504_30600)">
																	<path
																		d="M48.5215 39.9595C48.959 40.7456 49.8374 41.1301 50.738 41.125C52.2693 41.1182 53.4963 42.4221 53.3647 43.979C53.2485 45.3582 52.0044 46.375 50.6201 46.375H42V47.25H6.12498C4.62791 47.25 3.42479 45.9973 3.5034 44.4849C3.5786 43.0647 4.85179 42 6.27366 42H6.99998C8.06297 42 8.90379 41.0532 8.72606 39.9561C8.58592 39.0964 7.77757 38.5 6.90599 38.5H2.62498C1.12791 38.5 -0.0752122 37.2473 0.00340108 35.7349C0.0785966 34.3147 1.35179 33.25 2.77366 33.25H8.31248C9.52073 33.25 10.5 32.2708 10.5 31.0625C10.5 29.8542 9.52073 28.875 8.31248 28.875C7.10423 28.875 6.12498 27.8958 6.12498 26.6875C6.12498 25.4792 7.10423 24.5 8.31248 24.5H15.75V18.375H9.18748C7.44261 18.375 6.03612 16.9138 6.13011 15.1484C6.21556 13.4924 7.70237 12.25 9.36009 12.25H15.75V8.75H49.4375C51.1824 8.75 52.5888 10.2112 52.4949 11.9766C52.4094 13.6326 50.9226 14.875 49.2649 14.875H46.8125C45.0676 14.875 43.6611 16.3362 43.7551 18.1016C43.8406 19.7576 45.3274 21 46.9851 21H49C50.5552 21 51.7942 22.3535 51.6062 23.9446C51.449 25.2656 50.2527 26.1953 48.9248 26.2517C47.8772 26.2944 47.0688 27.26 47.2842 28.3555C47.4499 29.186 48.2326 29.75 49.0786 29.75H52.9375C54.6824 29.75 56.0888 31.2112 55.9949 32.9766C55.9094 34.6326 54.4226 35.875 52.7649 35.875H50.75C48.8325 35.875 47.3952 37.9309 48.5215 39.9595ZM2.18748 28.875C3.39573 28.875 4.37498 27.8958 4.37498 26.6875C4.37498 25.4792 3.39573 24.5 2.18748 24.5C0.979231 24.5 -1.6893e-05 25.4792 -1.6893e-05 26.6875C-1.6893e-05 27.8958 0.979231 28.875 2.18748 28.875ZM2.18748 28.875C3.39573 28.875 4.37498 27.8958 4.37498 26.6875C4.37498 25.4792 3.39573 24.5 2.18748 24.5C0.979231 24.5 -1.6893e-05 25.4792 -1.6893e-05 26.6875C-1.6893e-05 27.8958 0.979231 28.875 2.18748 28.875Z"
																		fill="#EFF6FE"
																	></path>
																	<path
																		d="M12.8 49V7H34.7516L45.2 17.4484V49H12.8Z"
																		fill="white"
																	></path>
																	<path
																		d="M33.6747 7.60002C34.2052 7.60002 34.7139 7.81074 35.0889 8.18581L44.0142 17.111C44.3892 17.4861 44.6 17.9948 44.6 18.5253V46.4C44.6 47.5046 43.7045 48.4 42.6 48.4H15.4C14.2954 48.4 13.4 47.5046 13.4 46.4V9.60002C13.4 8.49545 14.2954 7.60002 15.4 7.60002H33.6747ZM35.5857 6.98581C35.2107 6.61074 34.702 6.40002 34.1715 6.40002H14.2C13.0954 6.40002 12.2 7.29545 12.2 8.40002V47.6C12.2 48.7046 13.0954 49.6 14.2 49.6H43.8C44.9045 49.6 45.8 48.7046 45.8 47.6V18.0285C45.8 17.498 45.5892 16.9893 45.2142 16.6142L35.5857 6.98581Z"
																		fill="#E2EAF3"
																	></path>
																	<path
																		d="M34.4 17.8V7H34.7516L45.2 17.4484V17.8H34.4Z"
																		fill="white"
																	></path>
																	<path
																		d="M35 8.09682L44.1032 17.2H37C35.8955 17.2 35 16.3046 35 15.2V8.09682ZM35 6.40002H33.8V16.4C33.8 17.5046 34.6955 18.4 35.8 18.4H45.8V17.2L35 6.40002Z"
																		fill="#E2EAF3"
																	></path>
																	<path
																		d="M32.6 29.4028L29 32.8L34.4648 38.8H38.6V35.2L32.6 29.4028Z"
																		fill="#7AADF0"
																	></path>
																	<path
																		d="M36.2 22C35.5635 22 34.9531 22.2529 34.503 22.7029C34.0529 23.153 33.8 23.7635 33.8 24.4C33.8 25.0365 34.0529 25.647 34.503 26.0971C34.9531 26.5471 35.5635 26.8 36.2 26.8C36.8365 26.8 37.447 26.5471 37.8971 26.0971C38.3472 25.647 38.6 25.0365 38.6 24.4C38.6 23.7635 38.3472 23.153 37.8971 22.7029C37.447 22.2529 36.8365 22 36.2 22ZM36.2 38.8H19.4V34L25.4 28L36.2 38.8Z"
																		fill="#B5DEFF"
																	></path>
																</g>
																<defs>
																	<clipPath id="clip0_504_30600">
																		<rect
																			width="56"
																			height="56"
																			fill="white"
																		></rect>
																	</clipPath>
																</defs>
															</svg>
															<div class="mt-3">No Data found</div>
														</div>
													</div>{" "}
												</span>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

const styleObj = {
	snote: {
		color: "#657080",
		fontSize: "11px",
		fontWeight: "400",
		lineHeight: "18px",
	},
};

export default withRouter(NewLayoutDesign);



// WEBPACK FOOTER //
// ./src/components/crm/customer/NewLayoutDesign.js